export interface UWQuestionsState {
  isLoading: boolean | null;
};
export const initialState = {
  isLoading: null
};